<template>
  <div>
    <div v-if="cardId === undefined">
      <el-select v-model="checkId" placeholder="请选择" @change="queryCard()">
        <el-option v-for="item in cardList" :key="item.id" :label="item.name" :value="item.id"/>
      </el-select>
      <el-button style="margin-right: 10px" @click="addCard">新建</el-button>
    </div>
    <el-card>
      <div v-if="cardId === undefined" slot="header" class="clearfix">
        <el-input v-model="cardName" style="width: 300px"/>
        <el-button
            style="float: right; margin-right: 10px"
            type="text"
            @click="saveCard"
            :disabled="queryParameters.length === 0 && queryFunctionShowList.length === 0"
        >保存</el-button>
        <el-button style="float: right; margin-right: 10px" type="text" @click="functionAddDialog = true,functionAdd = {}">添加展示信息</el-button>
        <el-button style="float: right; margin-right: 10px" type="text" @click="queryParameterAdd">添加参数</el-button>
      </div>
      <div v-if="cardId !== undefined" slot="header" class="clearfix">
        <span>{{cardName}}</span>
      </div>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item v-if="item.isShow == 1" v-for="item in queryParameters.filter(item1=>item1.isShow===1)" :label="item.parameterLabel">
            <el-input v-if="item.parameterType==='String'" v-model="item.parameterValue"/>
            <el-date-picker
                v-if="item.parameterType==='Date'"
                v-model="item.parameterValue"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-date-picker
                v-if="item.parameterType==='DateInteger'"
                v-model="item.parameterValue"
                type="datetime"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
            <el-input v-if="item.parameterType==='Number'" v-model="item.parameterValue"/>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row v-for="(item,index) in queryFunctionShowList.filter(_item=>isEmpty(_item.triggerConditions))">
        <el-button v-if="cardId === undefined" @click="functionAdd = item,functionUpdateDialog = true,functionUpdateIndex = index">编辑</el-button>
        <TableOnlyQuery
            :function_id="item.functionId"
            :queryParametersInput="getParameterWithId(item.parameters)"
            @tableCellClick="tableCellClick"
            @tableCellDblclick="tableCellDblclick"
            @tableRowClick="tableRowClick"
            @tableRowContextmenu="tableRowContextmenu"
            @tableHeaderClick="tableHeaderClick"
            @tableHeaderContextmenu="tableHeaderContextmenu"
            @tableRowDblclick="tableRowDblclick"
        />
      </el-row>
    </el-card>
    <el-dialog
        title="添加请求参数"
        :visible.sync="parameterAddDialog"
        width="80%">
      <el-form>
        <el-form-item label="名称">
          <el-input
              v-model="parameterAdd.parameterLabel"
              style="width: 150px;"
          />
        </el-form-item>
        <el-form-item label="数据来源">
          <el-select v-model="parameterAdd.parameterType" placeholder="请选择数据来源">
            <el-option label="String" value="String"/>
            <el-option label="Date" value="Date"/>
            <el-option label="DateInteger" value="DateInteger"/>
            <el-option label="Number" value="Number"/>
          </el-select>
        </el-form-item>
        <el-form-item label="默认值">
          <el-select v-model="parameterAdd.parameterDefault" placeholder="默认值">
            <el-option v-for="item in functionSelfParameters" :key="item.parameterId" :label="item.parameterLabel" :value="item.parameterId"/>
          </el-select>
        </el-form-item>
        <el-button @click="parameterPush()">添加</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
        title="添加展示信息"
        :visible.sync="functionAddDialog"
        width="80%"
    >
      <el-form>
        <el-form-item label="数据来源">
          <el-select v-model="functionAdd.functionId" placeholder="请选择数据来源" @change="getFunctionParameter()">
            <el-option v-for="item in queryFunctionList" :key="item.id" :label="item.fnName" :value="item.id"/>
          </el-select>
        </el-form-item><div/>
        <div :key="functionAdd.functionId">
          <el-form-item v-for="param in functionAdd.parameters" :label="'参数绑定'+param.label">
            <el-select allow-create filterable v-model="param.value">
              <el-option v-for="item in getQueryParameters()" :key="item.parameterId" :label="item.parameterLabel" :value="item.parameterId"/>
            </el-select>
          </el-form-item><div/>
        </div>
        <el-form-item label="触发动作" v-if="!isEmpty(functionAdd.triggerConditionsTable)">
          <el-select
              v-model="functionAdd.triggerConditionsFunction"
              placeholder="请选择触发动作"
              clearable
              @change="triggerConditionsChange()"
          >
            <el-option v-for="item in triggerConditionsTypeList" :key="item.code" :label="item.name" :value="item.code"/>
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="addFunctionShowList()">添加展示信息</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
        title="编辑展示信息"
        :visible.sync="functionUpdateDialog"
        width="80%"
    >
      <el-form>
        <el-form-item label="数据来源">
          <el-select v-model="functionAdd.functionId" placeholder="请选择数据来源" @change="getFunctionParameter()">
            <el-option v-for="item in queryFunctionList" :key="item.id" :label="item.fnName" :value="item.id"/>
          </el-select>
        </el-form-item><div/>
        <div :key="functionAdd.functionId">
          <el-form-item v-for="param in functionAdd.parameters" :label="'参数绑定'+param.label">
            <el-select allow-create filterable v-model="param.value">
              <el-option v-for="item in getQueryParameters()" :key="item.parameterId" :label="item.parameterLabel" :value="item.parameterId"/>
            </el-select>
          </el-form-item><div/>
        </div>
        <el-form-item label="触发动作" v-if="!isEmpty(functionAdd.triggerConditionsTable)">
          <el-select
              v-model="functionAdd.triggerConditionsFunction"
              placeholder="请选择触发动作"
              clearable
              @change="triggerConditionsChange()"
          >
            <el-option v-for="item in triggerConditionsTypeList" :key="item.code" :label="item.name" :value="item.code"/>
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="updateFunctionShowList()">保存展示信息</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
        :visible.sync="triggerConditionsDialog"
        width="80%">
      <el-row v-for="item in queryFunctionShowList.filter(_item=>_item.triggerConditions === triggerConditionsType)">
        <TableOnlyQuery
            :function_id="item.functionId"
            :queryParametersInput="getParameterWithId(item.parameters)"
            @tableCellClick="tableCellClick"
            @tableCellDblclick="tableCellDblclick"
            @tableRowClick="tableRowClick"
            @tableRowContextmenu="tableRowContextmenu"
            @tableHeaderClick="tableHeaderClick"
            @tableHeaderContextmenu="tableHeaderContextmenu"
            @tableRowDblclick="tableRowDblclick"

        />
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import requestDB from "@/utils/requestDB";
import TableOnlyQuery from "./element/TableOnlyQuery.vue"
import da from "element-ui/src/locale/lang/da";

export default {
  components: {TableOnlyQuery},
  name: "PageCards",
  props: {
    cardId:{
      type: Number
    },
  },
  data() {
    return {
      checkId: 0,
      clickColumn: '',
      clickValues:[],
      cardName: '新建页面',
      queryParameters: [],//请求参数列表
      functionSelfParameters: [
        {isShow:0,parameterId:'@month-firstDay',parameterLabel:'本月第一天'},
        {isShow:0,parameterId:'@nextMonth-firstDay',parameterLabel:'下个月第一天'},
        {isShow:0,parameterId:'@month-endDay',parameterLabel:'本月最后一天'},
        {isShow:0,parameterId:'@now',parameterLabel:'当前时间'},
        {isShow:0,parameterId:'@now-1d',parameterLabel:'一天前'},
        {isShow:0,parameterId:'@now-1w',parameterLabel:'一周前'},
        {isShow:0,parameterId:'@now-1m',parameterLabel:'一月前'},
        {isShow:0,parameterId:'@now-1y',parameterLabel:'一年前'},
        {isShow:0,parameterId:'@userId',parameterLabel:'当前登陆人'}
      ],//页面参数列表
      parameterAddDialog: false,//添加请求参数弹窗
      parameterAdd: {},//添加的请求参数
      queryFunctionList: [],//所有数据来源
      functionAddDialog: false,//添加展示信息弹窗
      functionUpdateIndex : 0,
      functionUpdateDialog: false,//添加展示信息弹窗
      functionAdd: {},//添加的展示信息
      queryFunctionShowList: [],//展示数据来源
      triggerConditionsDialog: false,//触发条件弹窗
      triggerConditionsType: '',//触发条件标识
      triggerConditionsTable: 0,//触发表
      triggerConditionsFunction: '',//触发动作
      triggerConditionsTypeList: [
          {code:'tableCellClick',name:'单元格点击事件'},
          {code:'tableCellDblclick',name:'单元格双击事件'},
          {code:'tableRowClick',name:'行点击事件'},
          {code:'tableRowContextmenu',name:'右键菜单事件'},
          {code:'tableRowDblclick',name:'行双击事件'},
          // {code:'header-click',name:'表头点击事件'}
      ],//触发动作列表
      cardList : [],//所有页面

    }
  },
  mounted() {
    this.checkId = this.cardId
    this.getAllCards()
    this.getQueryParameter()
    this.queryCard()
  },
  methods: {
    getQueryParameters(){
      let _clickValue = []
      if (
          this.functionAdd.triggerConditionsFunction === 'tableCellClick' ||
          this.functionAdd.triggerConditionsFunction === 'tableCellDblclick')
      {
        _clickValue.push({isShow:0,parameterId:'_clickColumn',parameterLabel:'点击单元格数据'})
      } else if (
          this.functionAdd.triggerConditionsFunction === 'tableRowClick' ||
          this.functionAdd.triggerConditionsFunction === 'tableRowDblclick')
      {
        _clickValue.push({isShow:0,parameterId:'_clickRow',parameterLabel:'点击行数据'})
      }
      return [...this.queryParameters,...this.functionSelfParameters, ..._clickValue]
    },
    addCard(){
      this.checkId = undefined
      this.queryCard()
    },
    getAllCards() {
      requestDB.post("/card-show/findAll").then(result => {
        this.cardList = result.data
      })
    },
    //添加请求参数
    queryParameterAdd() {
      this.parameterAdd = {isShow:1,parameterId:'$'+this.queryParameters.length}
      this.parameterAddDialog = true
    },
    parameterPush() {
      this.queryParameters.push(this.parameterAdd)
      this.parameterAddDialog = false;
    },
    triggerConditionsChange(){
      this.functionAdd.triggerConditions =
          `table${this.functionAdd.triggerConditionsTable}_${
        this.functionAdd.triggerConditionsFunction.startsWith('tableCell') ?
            (this.functionAdd.triggerConditionsFunction + '_' + this.clickColumn) : functionAdd.triggerConditionsFunction
      }`
    },
    getDefaultValue(valueDefault,itemType){
      let value = null
      if (valueDefault && valueDefault.length > 0 && valueDefault[0] === '@'){
        switch (valueDefault) {
          case '@month-firstDay':
            var data = new Date(); //本月
            data.setDate(1);
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
            value = data.getTime()
            break;
          case '@nextMonth-firstDay':
            var currentDate = new Date();
            var nextMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 0, 0, 0, 0);
            var timestamp = nextMonthFirstDay.getTime();
            value = timestamp
            break;
          case '@month-endDay':
            var currentDate = new Date();
            var nextMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 0, 0, 0, 0);
            var timestamp = nextMonthFirstDay.getTime();
            value = timestamp-1000
            break;
          case '@now':
            value = new Date().getTime()
            break;
          case '@now-1d':
            value = new Date().getTime() - 86400000
            break;
          case '@now-1w':
            value = new Date().getTime() - 604800000
            break;
          case '@now-1m':
            value = new Date().getTime() - 2592000000
            break;
          case '@now-1y':
            value = new Date().getTime() - 31536000000
            break;
          case '@userId':
            value = this.user.id
            break;
        }
      } else {
        switch (itemType){
          case "Integer":
          case "Double":
          case "DateInteger":
            value = Number(valueDefault)
            break;
        }
      }
      return value
    },
    queryCard(){
      if (!this.checkId){
        this.cardName = '新建页面'
        this.queryParameters = []
        this.queryFunctionShowList = []
        return
      }
      requestDB.post("/card-show/getCardById",this.checkId).then(result => {
        this.cardName = result.data.name
        this.checkId = result.data.id
        if(result.data.cardParameters){
          this.queryParameters = result.data.cardParameters.map(item => {
            return {
              ...item,
              parameterDefault:item.parameterValue,
              parameterValue: this.getDefaultValue(item.parameterValue,item.parameterType)
            }
          })
        }
        if(result.data.functionParams){
          this.queryFunctionShowList = result.data.functionParams.map(item => {
            return {
              ...item,
              parameters:item.functionParams.map(_param => {
                return {
                  ..._param,
                  index:_param.paramIndex,
                  id:_param.paramId
                }
              }),
            }
          })
        }
      })
    },
    setColumns(functionId){
    },
    saveCard(){
      let _query = {
        id:this.checkId,
        name: this.cardName,
        cardParameters:this.queryParameters.map(item => {
          return {
            ...item,
            parameterValue:item.parameterDefault
          }
        }),
        functionParams:this.queryFunctionShowList.map(item => {
          return {
            ...item,
            functionParams:item.parameters.map(_param => {
              return {
                ..._param,
                paramIndex:_param.index,
                paramId:_param.id
              }
            })
          }
        })
      }
      requestDB.post("/card-show/saveCard",_query).then(result => {
        this.$notify({
          title: '成功',
          message: '保存成功',
          type: 'success',

        })
      })
    },
    getParameterWithId(parameters) {
      if (!parameters){
        return []
      }
      let _query = []
      for (let i = 0; i < parameters.length; i++) {
        if (parameters[i].value.toString().startsWith("$")){
          const data = this.queryParameters.find(item1 => item1.parameterId === parameters[i].value)
          if (data) {
            _query.push({...parameters[i],value:data.parameterValue})
          } else {
            _query.push(parameters[i])
          }
        } else if (parameters[i].value.toString().startsWith("_")){
          const data = this.clickValues.find(item1 => item1.parameterId === parameters[i].value)
          if (data) {
            _query.push({...parameters[i],value:data.parameterValue})
          } else {
            _query.push(parameters[i])
          }
        } else {
          _query.push(parameters[i])
        }
      }
      return _query
    },
    //获取所有数据来源
    getQueryParameter() {
      requestDB.post("/function-main/findAll/").then(result => {
        this.queryFunctionList = result.data
      })
    },
    addFunctionShowList(){
      this.queryFunctionShowList.push(this.functionAdd);
      this.functionAddDialog = false
    },
    updateFunctionShowList(){
      this.queryFunctionShowList[this.functionUpdateIndex] = this.functionAdd
      this.functionUpdateDialog = false
    },

    //获取数据来源参数
    async getFunctionParameter(){
      requestDB.post("/parameters/getByFunctionId/"+this.functionAdd.functionId).then(res => {
        this.functionAdd.parameters = res.data
      }).then(() =>{
        this.$forceUpdate();
      })
    },
    isEmpty(obj) {
      return obj === undefined || obj === null || obj === ''
    },
    tableCellClick(_ret){
      let {row, column, cell, event} = _ret
      this.clickValues = [{name:'_clickColumn',parameterValue:row[column.property]}]
      let _data = this.queryFunctionShowList.filter(_item=>{
        let _b = _item.triggerConditions === event
        return _b
      })
      if (_data && _data.length !== 0){
        this.triggerConditionsType = event
      }
      this.triggerConditionsDialog = this.triggerConditionsDialog || (_data && _data.length !== 0)
    },
    tableRowClick({row, column, event}){
      this.clickValues = [
        {name:'_clickRow',parameterValue:row},
        {name:'_clickColumn',parameterValue:row[column.property]}
      ]
      let _data = this.queryFunctionList.filter(_item=>_item.triggerConditions && _item.triggerConditions === event)

      if (_data && _data.length !== 0){
        this.triggerConditionsType = event
      }
      this.triggerConditionsDialog = this.triggerConditionsDialog || (_data && _data.length !== 0)
    },
    tableHeaderClick(ret){
      if (this.cardId !== undefined){
        return
      }
      this.functionAdd = {
        triggerConditionsTable : ret.table
      }
      this.clickColumn = ret.column.property
      this.functionAddDialog = true
    },
    tableCellDblclick({row, column, cell, event}){
      if (this.cardId !== undefined){
        return
      }
      this.clickValues = [
        {name:'_clickColumn',parameterValue:row[column.property]}
      ]
      let _data = this.queryFunctionList.filter(_item=>_item.triggerConditions && _item.triggerConditions === event)

      if (_data && _data.length !== 0){
        this.triggerConditionsType = event
      }
      this.triggerConditionsDialog = this.triggerConditionsDialog || (_data && _data.length !== 0)
    },
    tableRowDblclick({row, column, event}){
      this.clickValues = [
        {name:'_clickRow',parameterValue:row},
        {name:'_clickColumn',parameterValue:row[column.property]}
      ]
      let _data = this.queryFunctionList.filter(_item=>_item.triggerConditions && _item.triggerConditions === event)
      if (_data && _data.length !== 0){
        this.triggerConditionsType = event
      }
      this.triggerConditionsDialog = this.triggerConditionsDialog || (_data && _data.length !== 0)
    },
    tableRowContextmenu({row, column, event}){
      let _data = this.queryFunctionList.filter(_item=>_item.triggerConditions && _item.triggerConditions === event)
      if (_data && _data.length !== 0){
        this.triggerConditionsType = event
      }
      this.triggerConditionsDialog = this.triggerConditionsDialog || (_data && _data.length !== 0)
    },
    tableHeaderContextmenu(ret){
      // console.log("tableHeaderContextmenu",ret)
    },

  }
}
</script>
<style scoped>

</style>